
<div class="d-flex flex-column justify-content-center align-items-center">
    <app-tutor-new class="w-100 px-2"></app-tutor-new>
</div>

<div class="d-flex flex-column justify-content-center align-items-center my-3">
    <a class="button-link-primary-color fs-5 my-2" [routerLink]="loginUrl" routerLinkActive="active">
        {{loginLabel}}
    </a>
</div>
